import React, { FC, RefObject, useEffect, useRef, useState } from "react";
import Modal from "@mui/material/Modal";
import TextField from "@mui/material/TextField";
import Divider, { dividerClasses } from "@mui/material/Divider";
import classes from "./RecordDetailForm.module.scss";
import {
  colorSelectRuturnCode,
  colorSelectRuturnCodeLite,
} from "../../commons/columnColor";
import { useRecoilValue } from "recoil";
import { userState } from "../../states/userState";
import {
  backColorModal,
  backGroundColorCode,
  backgroundColor,
} from "../../commons/colors";
import RecordDetailHeader from "./Header/RecordDetailHeader";
import CompDateContainer from "./input/CompDateContainer";
import { useUpdateProcesses } from "../../hooks/useUpdateProcesses";
type Props = {
  setIsShow: React.Dispatch<React.SetStateAction<boolean>>;
  data: any;
  tableData: any;
  setTableData: any;
};
export type ProcessInfo = {
  id: string;
  date: Date | string;
};

const convertidentifer = (identifer: string, viewId: number) => {
  if (identifer === "base") return "B_";
  if (identifer === "site") return "S_";
  if (identifer === "schedule") {
    if (viewId === 0 || viewId === 50111 || viewId === 5253 || viewId == 54) {
      return "PTS_";
    } else {
      return "PVS_";
    }
  }
  if (identifer === "complete") {
    if (viewId === 0 || viewId === 50111 || viewId === 5253 || viewId == 54) {
      return "PTC_";
    } else {
      return "PVC_";
    }
  }
  if (identifer === "processCommon") {
    if (viewId === 0 || viewId === 50111 || viewId === 5253 || viewId == 54) {
      return "PT_";
    } else {
      return "PV_";
    }
  }
  return "B_";
};

const RecordDetailForm: FC<Props> = (props) => {
  const { setIsShow, data, setTableData, tableData } = props;
  const [targetProcess, setTargetProcess] = useState<ProcessInfo>({
    id: "",
    date: "",
  });
  const user = useRecoilValue(userState);
  //ダイアログの操作
  const [open, setOpen] = useState(true);
  const { updateProcessesPt, updateProcessesPv, putError } =
    useUpdateProcesses();
  const [compDate, setCompDate] = useState("初期値"); //カード読み取りの結果

  const createData = (data: any, identifer: string) => {
    const convertedIdentifer = convertidentifer(identifer, user.viewId);
    return data
      .map((row: any) => {
        const item = row.getContext();
        return item.column.id.startsWith(convertedIdentifer)
          ? { id: item.column.id, text: item.getValue() }
          : null;
      })
      .filter((item: any) => item !== null);
  };
  //配列の初期化
  const baseData = createData(data, "base");

  const processData = createData(data, "processCommon");
  const recordNo = processData.find(
    (item: any) =>
      item.id === "PT_レコード番号" || item.id === "PV_レコード番号"
  ).text;
  const processScheduledData = createData(data, "schedule");
  const processCompleteData = createData(data, "complete");
  console.log(
    "data",
    data,
    "processData",
    processData,
    "PS",
    processScheduledData,
    "PC",
    processCompleteData,
    "tableData",
    tableData,
    "recordNo",
    recordNo
  );

  const mapScheduledToCompleted = (scheduledId: string) => {
    if (
      user.viewId === 0 ||
      user.viewId === 50111 ||
      user.viewId === 5253 ||
      user.viewId == 54
    ) {
      return scheduledId.replace("PTS_", "PTC_").replace("予定", "完了");
    } else {
      return scheduledId.replace("PVS_", "PVC_").replace("予定", "完了");
    }
  };
  // Sorting the processCompleteData according to processScheduledData
  const sortedProcessCompleteData = processScheduledData.map((item: any) => {
    const completedId = mapScheduledToCompleted(item.id);
    const foundItem = processCompleteData.find(
      (completeItem: any) => completeItem.id === completedId
    );
    return foundItem || { id: completedId, text: "" }; // Fallback if not found, should not happen in normal conditions
  });

  const [proceeComleteDataState, setProcessCompleteDataState] = useState(
    sortedProcessCompleteData
  );
  //const processData = createData(data, "PP_");並び替え
  const siteData = createData(data, "site");
  const isMultiLine = (name: string) => {
    if (name === "現場名" || name === "備考") {
      return true;
    }
  };
  const dateRegex = /^\d{4}-\d{2}-\d{2}[A-Za-z]+$/;
  const isFinished = (text: string) => {
    return dateRegex.test(text);
  };
  // console.log(
  //   "data",
  //   data,
  //   "processData",
  //   processData,
  //   "PS",
  //   processScheduledData,
  //   "PC",
  //   processCompleteData,
  //   "tableData",
  //   tableData,
  //   "recordNo",
  //   recordNo
  // );
  const handleCompleteDateChange = (id: string, value: string) => {
    setProcessCompleteDataState((prevState: any) => {
      const newState = [...prevState];
      const index = prevState.findIndex((item: any) => item.id === id);
      newState[index].text = value;
      return newState;
    });
  };
  //キャンセルして閉じる
  const handleCancelButtonClick = () => {
    // setSendArray([]);
    setOpen(false);
    setIsShow(false);
  };
  //保存して閉じる
  const handleSaveButtonClick = async () => {
    let keyString = "";
    if (
      user.viewId === 0 ||
      user.viewId === 50111 ||
      user.viewId === 5253 ||
      user.viewId == 54
    ) {
      keyString = "PT_レコード番号";
    } else {
      keyString = "PV_レコード番号";
    }
    const targetTableData = tableData.filter(
      (data: any) => data[keyString] === recordNo
    )[0];
    const updateData = proceeComleteDataState.map((item: any) => ({
      id: item.id,
      text: item.text,
    }));
    const updatedTableData = updateTargetData(targetTableData, updateData);
    // const updatedTableData = targetTableData.map((item: any) => {
    //   const key = Object.keys(item)[0];
    //   const value = item[key];
    //   const updatedValue = updateData.find(
    //     (updateItem: any) => updateItem.id === key
    //   );
    //   return updatedValue ? { [key]: updatedValue.text } : { [key]: value };
    // });
    // console.log(
    //   "targetTableData",
    //   targetTableData,
    //   "updateData",
    //   updateData,
    //   "updatedTableData",
    //   updatedTableData
    // );
    console.log("DebugtableData", tableData, updateData, updatedTableData);

    setTableData((tableData: any) => {
      return tableData.map((item: any) =>
        item[keyString] === recordNo ? updatedTableData : item
      );
    });

    const updateDataForKintone = proceeComleteDataState.map((item: any) => {
      let newId = "";
      if (
        user.viewId === 0 ||
        user.viewId === 50111 ||
        user.viewId === 5253 ||
        user.viewId == 54
      ) {
        newId = item.id.replace("PTC_", "");
      } else {
        newId = item.id.replace("PVC_", "");
      }
      return {
        id: newId,
        text: item.text !== "" ? item.text.replace("F", "") : item.text,
      };
    });
    if (
      user.viewId === 0 ||
      user.viewId === 50111 ||
      user.viewId === 5253 ||
      user.viewId == 54
    ) {
      await updateProcessesPt(
        updateDataForKintone,
        Number(recordNo),
        user.mail
      );
    } else {
      await updateProcessesPv(
        updateDataForKintone,
        Number(recordNo),
        user.mail
      );
    }
    setOpen(false);
    setIsShow(false);
  };
  //更新用テーブルの配列を生成
  const updateTargetData = (targetData: any, updates: any) => {
    // 新しいオブジェクトを作成して、元のデータをコピー
    const updatedData = { ...targetData };
    console.log("DEBUGupdatedData", updatedData, "updates", updates);
    // updatesの各要素に対してループ
    updates.forEach((update: any) => {
      // updatedDataのキーをループして更新対象を探す
      Object.keys(updatedData).forEach((key) => {
        // キーがupdateのidと一致する場合、そのキーの値をupdateのtextで更新
        if (key === update.id) {
          updatedData[key] = update.text;
        }
      });
    });
    return updatedData;
  };
  useEffect(() => {
    if (putError) alert(putError);
  }, [putError]);

  //デバッグ用
  // useEffect(() => {
  //   tableData.forEach((item: any) => {
  //     if (item["P_レコード番号"] === recordNo) {
  //       console.log("item", item);
  //     }
  //   });
  // }, [tableData]);
  // console.log("baseData", baseData, colorSelectRuturnCode("B_"));
  const dividerStyle = (color: string) => {
    let styles = {
      borderColor: `${color}`, // 線の色をテーマのプライマリーカラーに設定
      fontSize: "18px",
      marginBottom: "0px",
      // Dividerにテキストがある場合、テキストのスタイルもここで定義できます
      "&::before, &::after": {
        // Dividerの線のスタイルをカスタマイズ
        borderTopColor: `${color}`, // これにより、線の色が変わります
      },
      color: `${color}`, // テキストの色を変更
      "@media (max-width: 600px)": {
        fontSize: "14px", // フォントサイズを14pxに設定
      },
    };
    return styles;
  };
  const inputStyle = (name: string, color: string) => {
    let styles = {
      "&&&": {
        color: `${color}`,
        width: "230px",
        margin: "0 0 0 0",
        // backgroundColor:"#dedede",
        "@media (max-width: 600px)": {
          width: "110px", // デフォルトの幅を110pxに設定
        },
      },
      "& input": {
        paddingTop: 0,
        paddingBottom: 0,
        padding: " 0 2px",
        fontSize: "12px",
        height: "36px",
        color: `${color}`,
        border: `1px solid ${color}`,
        textAlign: "center",
        borderRadius: "5px",
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis",
        "@media (max-width: 600px)": {
          fontSize: "11px", // フォントサイズを14pxに設定
          height: "30px",
        },
      },
      "& .MuiInputBase-input": {
        color: `${color}`, // 入力文字の色
        backgroundColor: backGroundColorCode(user?.mode ?? "lite"),
        // #202226",
      },
      "& label": {
        fontSize: "14px",
        color: `${color}`, // 通常時のラベル色
        "@media (max-width: 600px)": {
          fontSize: "12px", // フォントサイズを14pxに設定
        },
        //backgroundColor:"white"
      },
      "& label.Mui-focused": {
        color: `${color}`, // ラベルの色`${color}`指定
      },
      "& .MuiInput-underline:before": {
        borderBottomColor: `${color}`, // 通常時のボーダー色
      },
      "& .MuiInput-underline:hover:not(.Mui-disabled):before": {
        borderBottomColor: `${color}`, // ホバー時のボーダー色
      },
      "& .MuiOutlinedInput-root": {
        "& fieldset": {
          borderColor: `${color}`, // 通常時のボーダー色(アウトライン)
        },
        "&:hover fieldset": {
          borderColor: `${color}`, // ホバー時のボーダー色(アウトライン)
        },
      },
    };
    if (name.includes("日時") || name === "仕上名") {
      styles["&&&"].width = "120px";
      styles["&&&"]["@media (max-width: 600px)"] = { width: "100px" };
    } else if (
      name === "製作工場名" ||
      name === "出荷工場名" ||
      name === "製番" ||
      name === "製作番号" ||
      name === "事業所名"
    ) {
      styles["&&&"].width = "90px";
      styles["&&&"]["@media (max-width: 600px)"] = { width: "80px" };
    } else if (name === "担当名" || name === "得意先名") {
      styles["&&&"].width = "160px";
      styles["&&&"]["@media (max-width: 600px)"] = { width: "120px" };
    } else if (
      name === "状況区分名" ||
      name === "受架台入荷" ||
      name === "手摺タラ入荷"
    ) {
      styles["&&&"].width = "90px";
      styles["&&&"]["@media (max-width: 600px)"] = { width: "80px" };
    } else if (name === "保温名") {
      styles["&&&"].width = "120px";
      styles["&&&"]["@media (max-width: 600px)"] = { width: "100px" };
    } else {
      // 他の条件に基づいて必要ならばここで調整
      styles["&&&"].width = "70px"; // この行はデフォルトの幅設定と同じなので、実際には不要かもしれません
      styles["&&&"]["@media (max-width: 600px)"] = { width: "65px" };
    }

    return styles;
  };
  const inputStyleProcess = (
    name: string,
    color: string,
    isFinished: boolean
  ) => {
    let styles = {
      "&&&": {
        color: `${color}`,
        width: "230px",
        "@media (max-width: 600px)": {
          width: "110px", // デフォルトの幅を110pxに設定
        },
        margin: "0 0 0 0",
        // backgroundColor:"#dedede",
      },
      "& input": {
        paddingTop: 0,
        paddingBottom: 0,
        padding: " 0 2px",
        fontSize: "12px",
        height: "36px",
        color: `${color}`,
        border: `1px solid ${color}`,
        textAlign: "center",
        borderRadius: "5px",
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis",
        "@media (max-width: 600px)": {
          fontSize: "11px", // フォントサイズを14pxに設定
          height: "30px",
        },
      },
      "& .MuiInputBase-input": {
        color: isFinished ? "#00556f" : `${color}`, // 入力文字の色
        backgroundColor: isFinished
          ? "#b3fea1"
          : backGroundColorCode(user?.mode ?? "lite"),
      },
      "& label": {
        fontSize: "14px",
        color: `${color}`, // 通常時のラベル色
        "@media (max-width: 600px)": {
          fontSize: "12px", // フォントサイズを14pxに設定
        },
        //backgroundColor:"white"
      },
      "& label.Mui-focused": {
        color: `${color}`, // ラベルの色`${color}`指定
      },
      "& .MuiInput-underline:before": {
        borderBottomColor: `${color}`, // 通常時のボーダー色
      },
      "& .MuiInput-underline:hover:not(.Mui-disabled):before": {
        borderBottomColor: `${color}`, // ホバー時のボーダー色
      },
      "& .MuiOutlinedInput-root": {
        "& fieldset": {
          borderColor: `${color}`, // 通常時のボーダー色(アウトライン)
        },
        "&:hover fieldset": {
          borderColor: `${color}`, // ホバー時のボーダー色(アウトライン)
        },
      },
    };
    if (name.includes("日時")) {
      styles["&&&"].width = "120px";
      styles["&&&"]["@media (max-width: 600px)"] = { width: "110px" };
    } else if (name === "製番" || name === "製作番号") {
      styles["&&&"].width = "90px";
      styles["&&&"]["@media (max-width: 600px)"] = { width: "80px" };
    } else if (
      name === "営業番号" ||
      name === "レコード番号" ||
      name === "製作工場" ||
      name === "事業所名"
    ) {
      styles["&&&"].width = "70px";
      styles["&&&"]["@media (max-width: 600px)"] = { width: "80px" };
    } else {
      // 他の条件に基づいて必要ならばここで調整
      styles["&&&"].width = "90px"; // この行はデフォルトの幅設定と同じなので、実際には不要かもしれません
      styles["&&&"]["@media (max-width: 600px)"] = { width: "70px" };
    }

    return styles;
  };
  const inputStyleSite = (name: string, color: string, isFinished: boolean) => {
    let styles = {
      "&&&": {
        color: `${color}`,
        width: "230px",
        margin: "0 0 0 0",
        // backgroundColor:"#dedede",
      },
      "& input": {
        paddingTop: 0,
        paddingBottom: 0,
        padding: " 0 2px",
        fontSize: "12px",
        height: "36px",
        color: `${color}`,
        border: `1px solid ${color}`,
        textAlign: "center",
        borderRadius: "5px",
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis",
        "@media (max-width: 600px)": {
          fontSize: "11px", // フォントサイズを14pxに設定
          height: "30px",
        },
      },
      "& .MuiInputBase-input": {
        color: isFinished ? "#00556f" : `${color}`, // 入力文字の色
        backgroundColor: isFinished
          ? "#b3fea1"
          : backGroundColorCode(user?.mode ?? "lite"),
      },
      "& label": {
        fontSize: "14px",
        color: `${color}`, // 通常時のラベル色
        "@media (max-width: 600px)": {
          fontSize: "12px", // フォントサイズを14pxに設定
        },
        //backgroundColor:"white"
      },
      "& label.Mui-focused": {
        color: `${color}`, // ラベルの色`${color}`指定
      },
      "& .MuiInput-underline:before": {
        borderBottomColor: `${color}`, // 通常時のボーダー色
      },
      "& .MuiInput-underline:hover:not(.Mui-disabled):before": {
        borderBottomColor: `${color}`, // ホバー時のボーダー色
      },
      "& .MuiOutlinedInput-root": {
        "& fieldset": {
          borderColor: `${color}`, // 通常時のボーダー色(アウトライン)
        },
        "&:hover fieldset": {
          borderColor: `${color}`, // ホバー時のボーダー色(アウトライン)
        },
      },
    };
    if (name.includes("日時")) {
      styles["&&&"].width = "120px";
    } else if (name === "製番" || name === "製作番号" || name === "工事種名") {
      styles["&&&"].width = "90px";
    } else {
      // 他の条件に基づいて必要ならばここで調整
      styles["&&&"].width = "80px"; // この行はデフォルトの幅設定と同じなので、実際には不要かもしれません
    }

    return styles;
  };
  const inputMultiStyle = (name: string, color: string) => {
    let styles = {
      backgroundColor: backGroundColorCode(user?.mode ?? "lite"),
      borderRadius: "5px",
      fontSize: "14px",
      padding: "0 2px",
      width: "160px",
      "@media (max-width: 600px)": {
        fontSize: "12px", // フォントサイズを14pxに設定
        width: "120px",
      },
      "&&&": {
        padding: "0 2px",
      },
      "& .MuiInputBase-input": {
        color: `${color}`, // 入力文字の色
        fontSize: "12px",
        padding: "0 2px",
        "@media (max-width: 600px)": {
          fontSize: "10px", // フォントサイズを14pxに設定
        },
      },
      //スピンボタンの無効化-効いていない
      ':global(input[type="number"]::-webkit-outer-spin-button)': {
        WebkitAppearance: "none",
        margin: 0,
      },
      ':global(input[type="number"]::-webkit-inner-spin-button)': {
        WebkitAppearance: "none",
        margin: 0,
      },

      "& label": {
        color: `${color}`, // 通常時のラベル色
        //backgroundColor:"white"
        fontSize: "14px",
        "@media (max-width: 600px)": {
          fontSize: "12px", // フォントサイズを14pxに設定
        },
      },
      "& label.Mui-focused": {
        color: `${color}`, // ラベルの色をprimary.mainに指定
      },
      "& .MuiInput-underline:before": {
        borderBottomColor: `${color}`, // 通常時のボーダー色
      },
      "& .MuiInput-underline:hover:not(.Mui-disabled):before": {
        borderBottomColor: `${color}`, // ホバー時のボーダー色
      },

      "& .MuiOutlinedInput-root": {
        "& fieldset": {
          borderColor: `${color}`, // 通常時のボーダー色(アウトライン)
        },
        "&:hover fieldset": {
          borderColor: `${color}`, // ホバー時のボーダー色(アウトライン)
        },
        "& .MuiInputBase-root": {
          padding: "0 2px",
        },
        "&.css-lc33rk-MuiInputBase-root-MuiOutlinedInput-root": {
          padding: "2px 2px",
          minHeight: "60px",
        },
      },
    };

    return styles;
  };
  //デバッグ用
  // useEffect(() => {
  //   console.log("targetProcess:", targetProcess, proceeComleteDataState[0].id);
  // }, [targetProcess]);
  //スクロール
  const divRef: RefObject<HTMLDivElement> = useRef<HTMLDivElement>(null);
  const scrollToIndex = (index: number) => {
    console.log(divRef.current);
    const rootNode = divRef.current;
    const divNode = rootNode?.querySelectorAll("div")[index];
    // console.log("divNode", divNode);
    divNode?.scrollIntoView({
      behavior: "smooth",
      block: "nearest",
      inline: "center",
    });
  };
  return (
    <Modal
      open={open}
      onClose={handleCancelButtonClick}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
      sx={{
        borderColor: "prmary.main",
        border: "none",
        "&:focus-visible": {
          borderColor: "prmary.main",
          outlineColor: "primary.main", // Assuming your theme's primary.main is the color you want
        },
      }}
    >
      <>
        <div
          className={classes.formContainer}
          style={backColorModal(user?.mode ?? "lite")}
          // onClick={handleCancelButtonClick}
        >
          <RecordDetailHeader
            onSave={handleSaveButtonClick}
            onCancel={handleCancelButtonClick}
            setCompDate={setCompDate}
            compDate={compDate}
            setTargetProcess={setTargetProcess}
            processData={processData}
            baseData={baseData}
          />
          <div className={classes.details}>
            {processScheduledData.length > 0 && (
              <div className={classes.mainContents}>
                <Divider
                  textAlign="left"
                  sx={dividerStyle(
                    user?.mode === "lite"
                      ? colorSelectRuturnCodeLite("PT_")
                      : colorSelectRuturnCode("PT_")
                  )}
                  variant="fullWidth"
                >
                  <span style={{ fontWeight: 700 }}>完了入力</span>
                </Divider>
                <div className={classes.completeContent} ref={divRef}>
                  {processScheduledData.map((item: any, index: number) => (
                    <div key={item.id}>
                      <CompDateContainer
                        title={proceeComleteDataState[index].id}
                        shceduledDay={item.text}
                        completedDay={proceeComleteDataState[index].text}
                        onChange={handleCompleteDateChange}
                        targetProcess={targetProcess}
                        scrollToIndex={scrollToIndex}
                        index={index}
                      />
                    </div>
                  ))}
                </div>
              </div>
            )}
            <div className={classes.spacer} />
            {processData.length > 0 && (
              <div className={classes.mainContents}>
                <Divider
                  textAlign="left"
                  sx={dividerStyle(
                    user?.mode === "lite"
                      ? colorSelectRuturnCodeLite("P_")
                      : colorSelectRuturnCode("P_")
                  )}
                  variant="fullWidth"
                >
                  工程情報
                </Divider>
                <div className={classes.content}>
                  {processData.map((item: any) => (
                    <div key={item.id}>
                      <TextField
                        label={
                          item.id.split("_")[1] === "レコード番号"
                            ? "ﾚｺｰﾄﾞID"
                            : item.id.split("_")[1]
                        }
                        variant="outlined"
                        value={item.text}
                        InputProps={{ readOnly: true }}
                        InputLabelProps={{ shrink: true }}
                        sx={
                          !isMultiLine(item.id.split("_")[1])
                            ? inputStyleProcess(
                                item.id.split("_")[1],
                                user?.mode === "lite"
                                  ? colorSelectRuturnCodeLite("P_")
                                  : colorSelectRuturnCode("P_"),
                                isFinished(item.text)
                              )
                            : inputMultiStyle(
                                item.id.split("_")[1],
                                user?.mode === "lite"
                                  ? colorSelectRuturnCodeLite("P_")
                                  : colorSelectRuturnCode("P_")
                              )
                        }
                        multiline={isMultiLine(item.id.split("_")[1])}
                        // helperText={errorWorkerName.text}
                        // disabled={isDisabled}
                        // error={errorWorkerName.isShow}
                      />
                    </div>
                  ))}
                </div>
              </div>
            )}
            {/* <h1>レコード詳細</h1> */}
            {siteData.length === 0 && baseData.length > 0 && (
              <div className={classes.mainContents}>
                <Divider
                  textAlign="left"
                  sx={dividerStyle(
                    user?.mode === "lite"
                      ? colorSelectRuturnCodeLite("B_")
                      : colorSelectRuturnCode("B_")
                  )}
                  variant="fullWidth"
                >
                  受注情報
                </Divider>
                <div className={classes.content}>
                  {baseData.map((item: any) => (
                    <div key={item.id}>
                      <TextField
                        label={
                          item.id.split("_")[1] === "レコード番号"
                            ? "ﾚｺｰﾄﾞID"
                            : item.id.split("_")[1]
                        }
                        variant="outlined"
                        value={item.text}
                        InputProps={{ readOnly: true }}
                        InputLabelProps={{ shrink: true }}
                        sx={
                          !isMultiLine(item.id.split("_")[1])
                            ? inputStyle(
                                item.id.split("_")[1],
                                user?.mode === "lite"
                                  ? colorSelectRuturnCodeLite("B_")
                                  : colorSelectRuturnCode("B_")
                              )
                            : inputMultiStyle(
                                item.id.split("_")[1],
                                user?.mode === "lite"
                                  ? colorSelectRuturnCodeLite("B_")
                                  : colorSelectRuturnCode("B_")
                              )
                        }
                        multiline={isMultiLine(item.id.split("_")[1])}
                        // helperText={errorWorkerName.text}
                        // disabled={isDisabled}
                        // error={errorWorkerName.isShow}
                      />
                    </div>
                  ))}
                </div>
              </div>
            )}
          </div>
        </div>
      </>
    </Modal>
  );
};

export default RecordDetailForm;
